import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { DataContext } from "../context/DataContext";
import Card from "./common/Card";
import CardContent from "./common/CardContent";
import PlaySvg from "../svg/PlaySvg";
import loadingSpin from "../images/loadingSpin.gif";
// import { faBan } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from "axios";
import NtwrkErrMsg from "./common/NtwrkErrMsg";

const Lessons = () => {
  // const [ lessons, setLessons ] = useState()
  const authContext = useContext(AuthContext);
  const dataContext = useContext(DataContext);
  // const studentVideos = authContext.studentVideos;
  const [studentVideos, setStudentVideos] = useState([]);
  const [netwrkErr, setNetwrkErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noVideos, setNoVideos] = useState(false);

  // const [currUrl, setCurrUrl] = useState('');
  const deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;

  const id = JSON.parse(localStorage.getItem("studentInfo"));
  const studentId = id[0].studentId;
  const schoolDomain = localStorage.getItem("schoolDomain");

  // currUrl && dataContext.setClickedVideoUrl()

  useEffect(() => {
    const getStudentVideos = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `${authContext.baseUrl}/student/getallvideoNew/${schoolDomain}/${studentId}/${deploymentIdx}`
        );
        console.log(data, "mydata");
        if (data.status) {
          setLoading(false);
          setStudentVideos(data.data);
          data.data.length <= 0 && setNoVideos(true);
        } else {
          setLoading(false);
          setNetwrkErr(true);
        }
      } catch (error) {
        setLoading(false);
        setNetwrkErr(true);
        // console.log(error)
      }
    };
    getStudentVideos();
  }, [dataContext.initialVideo]);

  //const videoDetails = [];

  // const videoDataExtract = (video) => {
  //     video.length && video.map( item => {
  //         return typeof item.Available_Videos === "object" && item.Available_Videos.map( video => {
  //             videoDetails.push({topic: video.topic, url: video.longurl});
  //         })
  //     });
  // }
  // videoDataExtract(studentVideos)

  // useEffect(() => {
  //     const getInitialVideo = () => videoDetails.length && dataContext.setInitialVideo(studentVideos[0])
  //     getInitialVideo()
  //     return () => {}
  // }, [])

  console.log(noVideos, "studentVideos.length");

  return (
    <Card>
      <div className="">
        <div className="mb-4 boxShadow w-full p-3">
          <CardContent title="Lessons" />
        </div>
        <div className="">
          {loading && (
            <div className="mt-4 mx-auto w-full">
              <img
                src={loadingSpin}
                className="mx-auto mt-0"
                alt="loading..."
              />
            </div>
          )}

          {studentVideos &&
            studentVideos.length > 0 &&
            studentVideos.slice(0, 4).map((video) => {
              return (
                <div
                  onClick={() => dataContext.setClickedVideoUrl(video.longurl)}
                  className="px-3 py-1 cursor-pointer"
                >
                  <div className="flex items-center">
                    <PlaySvg />
                    <span className="text-xs text-gray-200 font-semibold border-b mt-2 border-gray-600 pb-2 w-full ml-2">
                      {" "}
                      {video.topic}{" "}
                    </span>
                  </div>
                </div>
              );
            })}

          {studentVideos && noVideos && (
            <div className="mt-4 mx-auto w-full">
              <NtwrkErrMsg errMsg="No video lessons yet" showReload={false} />
            </div>
          )}

          {netwrkErr && (
            <div className="mt-4 mx-auto w-full">
              <NtwrkErrMsg
                errMsg="Oops! Something Went Wrong"
                showReload={true}
              />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export { Lessons };
